<template lang="pug">
div
  .showkiss(v-show='nextShow' @click='openAdd')
    span 下一步
    van-icon(name="arrow")
  .addNotePic(v-show='addpanel')
    .mpic
      .uploadpic(v-for='(item,index) in base64List' :key='index')
        van-image(:src='item.url' alt='点击截图' @click='cutDwg(index)')
        van-icon(v-show='item.hasKss' name='close' @click='delCutPic(index)')
      .right
        van-image.annotationClose(:src="require('@/CommonDP/mongeView/appView/images/pencilClose.png')" alt='关闭' srcset='' @click.stop='closefunc')
        van-image.next(:src="require('@/CommonDP/mongeView/appView/images/next.png')" alt='下一步' srcset='' @click.stop='nextfunc')
  //- 创建批注
  notationAdd(ref="notationAdd" :type="actionData.type")
</template>

<script>
import iconImage from "@/CommonDP/mongeView/appView/images/icon-cutImg.png";
import mongeService from "@/CommonDP/mongeView/service/monge-service";
import common from "@/CommonDP/mongeView/appView/component/common";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";
import notationAdd from "@/CommonDP/mongeView/appView/question/notationAdd.vue";

export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default() {
        return "";
      }
    }
  },
  components: { notationAdd },
  data () {
    return {
      base64List: [
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false }
      ],
      addpanel: false,
      picList: [],
      nextShow: false,
      checkContent: ''
    };
  },
  computed: {
    modelInfoData() {
      return JSON.parse(mongeApp.model.fileInfo);
    },
    modelPageFileName() {
      return mongeApp.model.modelPageFileName;
    }
  },
  watch: {
    $route: {
      // 亲测有效,我是用来监听路由query参数变化
      async handler() {
        this.checkContent = this.$route.query.checkContent;
        if (this.checkContent) {
          this.$toast("请选择点位放置云线描述");
          mongeApiMlib.setMapText(this.checkContent);
        }
      },
      deep: true
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init() {
      this.$toast('请绘制云线');
      this.AddCloudNot();
    },
    // 添加云线
    AddCloudNot() {
      mongeApiMlib.addAnnotation("", {
        callback: (type, data) => {
          if (type === Monge.CallbackType.ANNOTATION_ITEM_DONE) {
            this.nextShow = true;
          } else if (type === Monge.CallbackType.DONE) {
            this.screenCaptureByBox(data);
          }
        }
      });
    },
    openAdd() {
      mongeApiMlib.annotationEnd();
      this.nextShow = false;
      this.addpanel = true;
    },
    // 截图
    async cutDwg(val) {
      const cutpic = await common.startScreenShot('dwg');
      this.getAddCutPicList(cutpic, val);
    },
    getAddCutPicList(cutimglist, index) {
      this.base64List[index].url = cutimglist;
      this.base64List[index].hasKss = true;
    },
    // 批注截图下一步
    async nextfunc() {
      let { isH5 } = this.$route.query || {};
      if (isH5) {
        this.openNotationAdd();
      } else {
        this.$toast.loading({
          message: '截图存储中...',
          forbidClick: true,
          duration: 0,
          loadingType: 'spinner'
        });
        this.picList = [];
        for (const index in this.base64List) {
          if (this.base64List[index].hasKss) {
            this.picList.push(await this.getFileMD5(this.base64List[index].url));
          }
        }
        await this.$nextTick();
        let fileId, fileName, fileVersion;
        if (this.modelInfoData.fileObj) { // 多文件
          fileId = this.modelInfoData.fileObj.map(e => e.folderID).join();
          fileName = this.modelInfoData.fileObj.map(e => e.folderName).join();
          fileVersion = this.modelInfoData.fileObj.map(e => e.rvtVersion).join();
        } else {
          fileId = this.modelInfoData.fileId;
          fileName = this.modelInfoData.fileName;
          fileVersion = this.modelInfoData.rvtVersion;
        }
        const { prjId } = this.modelInfoData;
        const { fileType } = this.$route.query;
        const data = {
          fileId,
          fileName,
          fileType,
          versionIds: fileVersion,
          prjId,
          source: 'add',
          picList: this.picList,
          autoScreenshotMd5: "",
          modelPageFileName: this.modelPageFileName
        };
        console.log('uni参数', data);
        await mongeApiMlib.uniPostMessage(data);
        this.$toast.clear();
      }
      setTimeout(() => {
        this.base64List.forEach(itm => {
          itm.url = iconImage;// 清除截图
          itm.hasKss = false;// 去掉叉号
        });
        this.addpanel = false;// 关闭截图弹框
      }, 1500);
    },
    // 截全屏
    async screenCaptureByBox(data) {
      if (data.bbox) {
        const coordinate = JSON.stringify(data.data) || '';// 云线或锚点数据
        const dataUrl = await mongeApiMlib.mongeScreenCapture(false, 'dwg');
        let { isH5 } = this.$route.query || {};
        if (isH5) {
          this.finishNotationAdd(coordinate, dataUrl);
        } else {
          const autoScreenshotMd5 = await this.getFileMD5(dataUrl);
          const layoutName = this.spaceOfDwgData;
          let fileId, fileName, fileVersion;
          if (this.modelInfoData.fileObj) { // 多文件
            fileId = this.modelInfoData.fileObj.map(e => e.folderID).join();
            fileName = this.modelInfoData.fileObj.map(e => e.folderName).join();
            fileVersion = this.modelInfoData.fileObj.map(e => e.rvtVersion).join();
          } else {
            fileId = this.modelInfoData.fileId;
            fileName = this.modelInfoData.fileName;
            fileVersion = this.modelInfoData.rvtVersion;
          }
          const { prjId } = this.modelInfoData;
          const { fileType } = this.$route.query;
          const query = JSON.parse(JSON.stringify({ fileId, fileName, fileType, versionIds: fileVersion, prjId, source: 'sureAdd',
            picList: this.picList, autoScreenshotMd5: autoScreenshotMd5, modelPageFileName: this.modelPageFileName, layoutName, coordinate }));
          await mongeApiMlib.uniPostMessage(query);
        }
        await this.$nextTick();
        mongeApiMlib.annotationDeactive();
        this.$emit("closeCom", 'issue', false);
      }
    },
    async getFileMD5(base64) {
      const blob = this.dataURItoBlob(base64);
      const formData = new FormData();
      formData.set("files", blob);
      const res = await mongeService.picupload(formData);
      if (res.result === "0") {
        return res.data[0];
      }
    },
    dataURItoBlob(base64Data) {
      let byteString;
      if (base64Data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(base64Data.split(",")[1]);
      } else {
        byteString = unescape(base64Data.split(",")[1]);
      }
      const mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: mimeString });
      return blob;
    },
    // 删除截图
    delCutPic(index) {
      this.base64List[index].url = iconImage;
      this.base64List[index].hasKss = false;
    },
    closefunc() {
      this.addpanel = false;
    },

    // 打开创建批注
    openNotationAdd(){
      let { fileId, fileName, rvtVersion, fileObj, prjId } = this.modelInfoData;
      let fileList = []; // 当前文件
      if (fileObj) { // 多文件
        fileList = fileObj.map(ele => {
          return { fileId: ele.folderID, fileName: ele.folderName, fileVersion: ele.rvtVersion };
        });
        fileId = '';
      } else {
        fileList = [{ fileId, fileName, fileVersion: rvtVersion }]; 
      }
      const modelPageFileName = this.modelPageFileName;
      let picUrlList = [];
      this.base64List.forEach(pic => {
        if(pic.hasKss) picUrlList.push(pic.url);
      });
      const params = {prjId, fileId, fileList, modelPageFileName, picUrlList};
      this.$refs.notationAdd.open(params);
    },
    // 完成创建批注
    finishNotationAdd(coordinate, autoScreenshotUrl){
      const params = { coordinate, autoScreenshotUrl }; // 云线和自动截图url
      this.$refs.notationAdd?.createFinish(params);
    }
  }

};
</script>

<style lang="scss" scoped>
.showkiss{
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 12px;
  height: 30px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border-radius: 8px;
  line-height: 30px;
  bottom: 65px;
  cursor: pointer;
  right: 10px;
  z-index: 4;
  i{
    margin-left: 6px;
    font-size: 16px;
  }
}
.addNotePic{
    position: absolute;
    width: 100%;
    height: 70px;
    bottom: 48px;
    background: #FFFFFF;

    .mpic{
      width: 100%;
      height: 100%;
      padding: 0 15px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .uploadpic {
        width: 55px;
        height: 55px;
        margin-left: 8px;
        background: rgba(85, 132, 255, 0.1);
        text-align: center;
        position: relative;

        .van-image {
          width: 100%;
          height: 100%;
          display: block;
        }

        .van-icon{
          position: absolute;
          top: 0;
          right: 0;
          font-size: 16px;
          color: #ee0404;
        }

      }

      .uploadpic:first-child{
        margin-left: 0;
      }

      .right{
        margin-left: auto;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;

        .annotationClose {
          width: 15px;
          height: 15px;
          margin-right: 15px;
        }

        .next {
          color: #fff;
          width: 22px;
          height: 22px;
        }
      }
    }
  }
</style>
